import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { SecurityContextService } from '@services/security_context.service';
import { SyncWorkerSettingService } from '@services/sync-worker-setting.service';

export const NO_LONGER_AVAILABLE_PATH = 'no-longer-available';

export const redirectSyncWorkerAccountsGuard: CanActivateChildFn = async () => {
  const securityContextService = inject(SecurityContextService);
  const syncWorkerSettingService = inject(SyncWorkerSettingService);
  const router = inject(Router);

  if (!securityContextService.isLoggedIn()) {
    return true;
  }

  try {
    const isAccountOnSyncWorker =
      await syncWorkerSettingService.isAccountOnSyncWorker();
    return isAccountOnSyncWorker
      ? router.parseUrl(`/${NO_LONGER_AVAILABLE_PATH}`)
      : true;
  } catch (error) {
    console.error(error);
    return true;
  }
};
